/* Anatomia v3 e rodas EVA vs plástico — sem bibliotecas */
(function(){
  'use strict';
  if (window.__fsAn) return; window.__fsAn = 1;
  var NS = 'http://www.w3.org/2000/svg';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function(v,a,b){ return Math.max(a, Math.min(b, v)); };
  var seg = function(p,a,b){ return clamp((p-a)/(b-a), 0, 1); };
  var ease = function(t){ return t<.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2, 3)/2; };
  var easeOut = function(t){ return 1 - Math.pow(1-t, 3); };
  var lerp = function(a,b,t){ return a + (b-a)*t; };
  var el = function(tag, attrs, parent){
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  };
  var progress = function(sec){
    var r = sec.getBoundingClientRect(), d = sec.offsetHeight - window.innerHeight;
    return d > 0 ? clamp(-r.top / d, 0, 1) : 0;
  };
  var arcPath = function(r1, r2, a0, a1){
    var p = function(r,a){ return (r*Math.cos(a)).toFixed(2) + ' ' + (r*Math.sin(a)).toFixed(2); };
    var large = (a1 - a0) > Math.PI ? 1 : 0;
    return 'M' + p(r2,a0) + ' A' + r2 + ' ' + r2 + ' 0 ' + large + ' 1 ' + p(r2,a1) + ' L' + p(r1,a1) + ' A' + r1 + ' ' + r1 + ' 0 ' + large + ' 0 ' + p(r1,a0) + ' Z';
  };
  function art(part){
    var s = el('svg', {viewBox:'0 0 200 200', 'aria-hidden':'true'});
    el('use', {href:'#anArt-' + part}, s);
    return s;
  }

  /* Caixa do carro dentro da foto (fração da imagem), calculada pelos contornos */
  function findBBox(img, done){
    var go = function(){
      try {
        var nw = img.naturalWidth, nh = img.naturalHeight; if (!nw) return done(null);
        var W = Math.min(480, nw), H = Math.round(W*nh/nw);
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data, g = new Float32Array(W*H), i, j, k;
        for (i=0, j=0; i<d.length; i+=4, j++) g[j] = .299*d[i] + .587*d[i+1] + .114*d[i+2];
        var m = new Float32Array(W*H), mx = 0;
        for (var y=1; y<H-1; y++) for (var xx=1; xx<W-1; xx++){
          k = y*W + xx;
          var gx = -g[k-W-1] - 2*g[k-1] - g[k+W-1] + g[k-W+1] + 2*g[k+1] + g[k+W+1];
          var gy = -g[k-W-1] - 2*g[k-W] - g[k-W+1] + g[k+W-1] + 2*g[k+W] + g[k+W+1];
          var v = Math.sqrt(gx*gx + gy*gy); m[k] = v; if (v > mx) mx = v;
        }
        if (!mx) return done(null);
        var th = mx*.16, cols = new Uint32Array(W), rows = new Uint32Array(H);
        for (y=1; y<H-1; y++) for (xx=1; xx<W-1; xx++) if (m[y*W+xx] > th){ cols[xx]++; rows[y]++; }
        var need = Math.max(3, Math.round(H*.012)), needR = Math.max(3, Math.round(W*.012)), x0 = W, x1 = 0, y0 = H, y1 = 0;
        for (xx=0; xx<W; xx++) if (cols[xx] >= need){ x0 = Math.min(x0, xx); x1 = Math.max(x1, xx); }
        for (y=0; y<H; y++) if (rows[y] >= needR){ y0 = Math.min(y0, y); y1 = Math.max(y1, y); }
        if (x1 - x0 < W*.2 || y1 - y0 < H*.15) return done(null);
        done([x0/W, y0/H, x1/W, y1/H]);
      } catch(e){ done(null); }
    };
    if (img.complete && img.naturalWidth) go();
    else { img.addEventListener('load', go, {once:true}); img.addEventListener('error', function(){ done(null); }, {once:true}); }
  }

  /* Onde fica cada peça num carro visto a 3/4 de frente (fração da caixa do carro) */
  var SPOT = {led:[.16,.5], steering:[.5,.24], seat:[.64,.3], battery:[.56,.55], motor:[.8,.74], springs:[.72,.8], wheel:[.3,.8], remote:[.9,.16]};

  function initAnatomy(sec){
    var steps = [], meta = {}, pts = null;
    try { steps = JSON.parse(sec.querySelector('[data-an-steps]').textContent) || []; } catch(e){}
    try { meta = JSON.parse(sec.querySelector('[data-an-meta]').textContent) || {}; } catch(e){}
    try { pts = JSON.parse(sec.querySelector('[data-an-points]').textContent); } catch(e){}
    if (!steps.length){ sec.style.display = 'none'; return; }
    var N = steps.length;
    var stage = sec.querySelector('[data-stage]'), car = sec.querySelector('[data-car]'), lines = sec.querySelector('[data-lines]');
    var partsBox = sec.querySelector('[data-parts]'), tray = sec.querySelector('[data-tray]'), prog = sec.querySelector('[data-prog]');
    var spec = sec.querySelector('[data-spec]'), sIdx = sec.querySelector('[data-s-idx]'), sVal = sec.querySelector('[data-s-val]'),
        sName = sec.querySelector('[data-s-name]'), sTxt = sec.querySelector('[data-s-txt]'), sBuy = sec.querySelector('[data-s-buy]'), count = sec.querySelector('[data-count]');
    var ar = parseFloat(getComputedStyle(sec).getPropertyValue('--ar')) || 1;
    tray.style.setProperty('--n', N);
    var bb = [.08, .18, .92, .86];
    var P = steps.map(function(s, i){
      var d = document.createElement('div'); d.className = 'an__part'; d.appendChild(art(s.part)); partsBox.appendChild(d);
      var b = document.createElement('button'); b.type = 'button'; b.className = 'an__ti';
      var ic = document.createElement('i'); ic.appendChild(art(s.part)); b.appendChild(ic);
      var sp = document.createElement('span'); sp.textContent = s.short || s.name; b.appendChild(sp);
      b.setAttribute('aria-label', s.name);
      b.addEventListener('click', function(){ jump(i); });
      tray.appendChild(b);
      var ln = el('line', {}, lines), ring = el('g', {}, lines);
      el('circle', {r:16, 'class':'an__ring'}, ring); el('circle', {r:4, 'class':'an__dot'}, ring);
      return {s:s, el:d, ti:b, ic:ic, ln:ln, ring:ring};
    });
    var L = {}, tick = false, last = null, countT = 0;
    var I0 = .06, I1 = .9;

    function fit(w, h, a){ return a > w/h ? [w, w/a] : [h*a, h]; }
    function layout(){
      var W = stage.clientWidth, H = stage.clientHeight, mob = window.innerWidth < 750;
      var ls = parseFloat(getComputedStyle(sec).getPropertyValue('--ls')) || 160;
      var f0 = fit(W*(mob ? 1 : .86), H*(mob ? .78 : 1), ar), f1, R0, R1, F, S;
      R0 = [(W - f0[0])/2, mob ? 0 : (H - f0[1])/2, f0[0], f0[1]];
      if (mob){
        var room = Math.max(ls + 20, H*.4);
        f1 = fit(W, H - room, ar);
        R1 = [(W - f1[0])/2, 0, f1[0], f1[1]];
        var below = R1[1] + R1[3], cy = below + (H - below)/2;
        F = [ls/2 + 2, clamp(cy - 6, below + ls/2 + 4, H - ls/2)];
        S = [ls + 20, below + 12, W - ls - 20];
      } else {
        f1 = fit(W*.62, H, ar);
        R1 = [0, (H - f1[1])/2, f1[0], f1[1]];
        var colX = R1[2] + (W - R1[2])*.08, colW = W - colX;
        F = [colX + ls/2 + 6, Math.max(ls/2 + 8, H*.5 - 70)];
        S = [colX + ls + 44, F[1] - 58, Math.min(400, colW - ls - 50)];
      }
      lines.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      var sr = stage.getBoundingClientRect();
      var T = P.map(function(o){ var r = o.ic.getBoundingClientRect(); return [r.left - sr.left + r.width/2, r.top - sr.top + r.height/2, r.width/ls]; });
      L = {W:W, H:H, mob:mob, ls:ls, R0:R0, R1:R1, F:F, S:S, T:T, SE:mob ? [0, R1[1] + R1[3] + 14, W] : S};
      car.style.width = R1[2] + 'px'; car.style.height = R1[3] + 'px';
      placeSpec(false);
    }
    function placeSpec(end){
      var S = end ? L.SE : L.S;
      spec.style.left = S[0] + 'px'; spec.style.top = S[1] + 'px'; spec.style.width = S[2] + 'px';
      if (sVal.textContent) fitVal();
    }
    function anchor(part){
      var R = L.R1, f;
      if (pts && pts[part]) f = [pts[part][0]/100, pts[part][1]/100];
      else { var s = SPOT[part] || [.5,.5]; f = [bb[0] + s[0]*(bb[2]-bb[0]), bb[1] + s[1]*(bb[3]-bb[1])]; }
      return [R[0] + f[0]*R[2], R[1] + f[1]*R[3]];
    }
    function setSpec(c){
      if (last && last.key === c.key) return;
      last = c;
      spec.setAttribute('data-swap', '');
      clearTimeout(countT);
      countT = setTimeout(function(){
        sIdx.textContent = c.idx || ''; sName.textContent = c.name || ''; sTxt.textContent = c.txt || '';
        sBuy.hidden = !c.buy;
        spec.removeAttribute('data-swap');
        countUp(c.val || '');
      }, 180);
    }
    var cTok = 0;
    function fitVal(){
      sVal.style.fontSize = '';
      var fs = parseFloat(getComputedStyle(sVal).fontSize), w = spec.clientWidth;
      while (fs > 16 && sVal.scrollWidth > w + 1){ fs -= 1; sVal.style.fontSize = fs + 'px'; }
    }
    function countUp(v){
      var tok = ++cTok, m = /^(\d+)(\D.*|)$/.exec(v);
      sVal.textContent = v; fitVal();
      if (!m || RM) return;
      var n = +m[1], t0 = performance.now();
      (function f(t){ if (tok !== cTok) return; var q = Math.min(1, (t - t0)/700); sVal.textContent = Math.round(n*easeOut(q)) + m[2]; if (q < 1) requestAnimationFrame(f); })(t0);
    }
    function jump(i){
      var top = sec.getBoundingClientRect().top + window.scrollY, d = sec.offsetHeight - window.innerHeight;
      var p = I0 + (I1 - I0)*(i + .5)/N;
      window.scrollTo({top: top + d*p, behavior: RM ? 'auto' : 'smooth'});
    }
    function render(){
      tick = false;
      if (!L.W) layout();
      var p = RM ? .99 : progress(sec);
      var qi = ease(seg(p, 0, I0));
      var R = [lerp(L.R0[0], L.R1[0], qi), lerp(L.R0[1], L.R1[1], qi), lerp(L.R0[2], L.R1[2], qi)];
      var sc = R[2]/L.R1[2];
      car.style.transform = 'translate(' + R[0].toFixed(1) + 'px,' + R[1].toFixed(1) + 'px) scale(' + sc.toFixed(4) + ')';
      spec.style.opacity = qi.toFixed(3);
      var span = (I1 - I0)/N, k = Math.floor((p - I0)/span), t = (p - I0)/span - k;
      if (p < I0) k = -1;
      if (p >= I1) k = N;
      P.forEach(function(o, j){
        var st = 'hide', e = 0, d = 0;
        if (j === k){ e = easeOut(seg(t, 0, .34)); d = ease(seg(t, .76, 1)); st = 'act'; }
        var got = j < k || (j === k && d > .85);
        if (got) o.ti.setAttribute('data-got', ''); else o.ti.removeAttribute('data-got');
        if (j === k && d <= .85) o.ti.setAttribute('data-on', ''); else o.ti.removeAttribute('data-on');
        if (st !== 'act' || d > .97){ o.el.style.opacity = 0; o.ln.style.opacity = 0; o.ring.style.opacity = 0; return; }
        var A = anchor(o.s.part), Tt = L.T[j];
        var x = lerp(lerp(A[0], L.F[0], e), Tt[0], d), y = lerp(lerp(A[1], L.F[1], e), Tt[1], d);
        var s = lerp(lerp(.22, 1, e), Tt[2], d), r = (1 - e)*-16;
        o.el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + r.toFixed(1) + 'deg) scale(' + s.toFixed(3) + ')';
        o.el.style.opacity = Math.min(1, e*2).toFixed(3);
        var rad = L.ls*s/2, dx = x - A[0], dy = y - A[1], dist = Math.sqrt(dx*dx + dy*dy) || 1, lo = e*(1 - d);
        o.ln.setAttribute('x1', A[0].toFixed(1)); o.ln.setAttribute('y1', A[1].toFixed(1));
        o.ln.setAttribute('x2', (x - dx/dist*rad).toFixed(1)); o.ln.setAttribute('y2', (y - dy/dist*rad).toFixed(1));
        o.ln.style.opacity = (pts && dist > rad + 6 ? lo : 0).toFixed(3);
        o.ring.setAttribute('transform', 'translate(' + A[0].toFixed(1) + ' ' + A[1].toFixed(1) + ')');
        o.ring.style.opacity = (pts ? lo : 0).toFixed(3);
      });
      if (k < 0){ setSpec({key:'i', idx:meta.intro && meta.intro.idx, val:meta.intro && meta.intro.val, name:meta.intro && meta.intro.name}); count.innerHTML = ''; }
      else if (k >= N){ setSpec({key:'e', idx:meta.end && meta.end.idx, val:meta.end && meta.end.val, name:meta.end && meta.end.name, buy:1}); count.innerHTML = '<b>' + String(N).padStart(2,'0') + '</b> / ' + String(N).padStart(2,'0'); }
      else {
        var s0 = steps[k];
        setSpec({key:k, idx:String(k+1).padStart(2,'0') + ' / ' + String(N).padStart(2,'0') + ' · ' + s0.name, val:s0.val, name:'', txt:s0.txt});
        count.innerHTML = '<b>' + String(k+1).padStart(2,'0') + '</b> / ' + String(N).padStart(2,'0');
      }
      var isEnd = k >= N;
      if (isEnd !== !!L.end){ L.end = isEnd; placeSpec(isEnd); }
      if (isEnd) sec.setAttribute('data-end', ''); else sec.removeAttribute('data-end');
      prog.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      var r0 = sec.getBoundingClientRect();
      if (r0.top < window.innerHeight*.5 && r0.bottom > window.innerHeight*.5) document.body.setAttribute('data-an-on', ''); else document.body.removeAttribute('data-an-on');
    }
    var on = function(){ if (!tick){ tick = true; requestAnimationFrame(render); } };
    var vh = function(){ sec.style.height = (window.innerWidth < 750 ? 120 + N*52 : 130 + N*58) + 'vh'; };
    sBuy.textContent = sBuy.textContent.split('·')[0].trim();
    sBuy.addEventListener('click', function(e){
      var b = document.querySelector('.fs-buy');
      if (b){ e.preventDefault(); window.scrollTo({top: b.getBoundingClientRect().top + window.scrollY - 90, behavior: RM ? 'auto' : 'smooth'}); }
    });
    var src = sec.querySelector('[data-src-img]');
    if (src && !pts){
      var start = function(){ if (!src.getAttribute('src')) src.src = src.dataset.src; findBBox(src, function(b){ if (b){ bb = b; on(); } }); };
      if ('IntersectionObserver' in window){ var io = new IntersectionObserver(function(en){ if (en[0].isIntersecting){ io.disconnect(); start(); } }, {rootMargin:'800px'}); io.observe(sec); } else start();
    }
    window.addEventListener('scroll', on, {passive:true});
    window.addEventListener('resize', function(){ vh(); layout(); on(); });
    vh(); layout(); render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ layout(); on(); });
  }

  function drawCompareWheel(g, type){
    var R = 170, RI = 112, spin = g.querySelector('[data-spin]');
    if (type === 'eva'){
      el('circle', {r:R, fill:'#141518', stroke:'#2c2f34', 'stroke-width':1.5}, spin);
      for (var i=0;i<36;i++){ el('rect', {x:-7, y:-R-1, width:14, height:20, rx:2, fill:'#1f2125', transform:'rotate(' + (i*10) + ')'}, spin); }
      el('circle', {r:R-24, fill:'none', stroke:'#22252a', 'stroke-width':3}, spin);
      el('text', {y:-R+52, 'text-anchor':'middle', fill:'#5b616a', style:'font:600 15px Archivo,sans-serif;letter-spacing:.3em'}, spin).textContent = 'EVA';
    } else {
      el('circle', {r:R, fill:'url(#whPlastic)', stroke:'#4a4d53', 'stroke-width':1.5}, spin);
      for (var j=0;j<24;j++){ el('line', {x1:0, y1:-R+3, x2:0, y2:-R+12, stroke:'#55585e', 'stroke-width':2, transform:'rotate(' + (j*15) + ')'}, spin); }
      el('circle', {r:R-10, fill:'none', stroke:'#4a4d53', 'stroke-width':1}, spin);
    }
    el('circle', {r:RI, fill:'url(#whRim)', stroke:'#5b616a', 'stroke-width':1.2}, spin);
    for (var k=0;k<5;k++){ el('path', {d:'M-8 -20 L-20 -104 L-4 -106 L2 -20 Z M8 -20 L20 -104 L4 -106 L-2 -20 Z', fill:type === 'eva' ? '#2f333a' : '#34373c', stroke:'#4a4f57', 'stroke-width':.8, transform:'rotate(' + (k*72) + ')'}, spin); }
    el('circle', {r:18, fill:'#1d2025', stroke:'#5b616a'}, spin);
    el('circle', {r:6, fill:'#c9b48a'}, spin);
    var cut = el('g', {}, g);
    return {spin:spin, cut:cut, type:type, R:R, RI:RI};
  }
  function drawCut(w, sweep){
    var c = w.cut; while (c.firstChild) c.removeChild(c.firstChild);
    if (sweep <= .01) return;
    var a0 = -Math.PI/2 - sweep/2, a1 = -Math.PI/2 + sweep/2;
    if (w.type === 'eva'){
      el('path', {d:arcPath(w.RI, w.R, a0, a1), fill:'url(#whFoam)', stroke:'#f3f4f5', 'stroke-width':1.4, 'stroke-opacity':.7}, c);
    } else {
      el('path', {d:arcPath(w.RI, w.R, a0, a1), fill:'url(#whHollow)', stroke:'#f3f4f5', 'stroke-width':1.4, 'stroke-opacity':.7}, c);
      el('path', {d:arcPath(w.R-8, w.R, a0, a1), fill:'#8a8f96'}, c);
      el('path', {d:arcPath(w.RI, w.RI+8, a0, a1), fill:'#8a8f96'}, c);
      if (sweep > 1){ var t = el('text', {y:-(w.R+w.RI)/2 + 6, 'text-anchor':'middle', fill:'#a7adb4', style:'font:600 13px Archivo,sans-serif;letter-spacing:.3em'}, c); t.textContent = c.ownerSVGElement.dataset.hollow || 'OCO'; }
    }
  }
  function initWheels(sec){
    var eva = drawCompareWheel(sec.querySelector('[data-wh-wheel="eva"]'), 'eva');
    var pl = drawCompareWheel(sec.querySelector('[data-wh-wheel="pl"]'), 'pl');
    var evaG = sec.querySelector('[data-wh-wheel="eva"]'), plG = sec.querySelector('[data-wh-wheel="pl"]');
    var ground = sec.querySelector('[data-ground]'), bumpsG = sec.querySelector('[data-bumps]'), noise = sec.querySelector('[data-noise] path');
    var rows = sec.querySelectorAll('.wh__row'), phase = sec.querySelector('[data-wh-phase]'), bar = sec.querySelector('[data-wh-bar]');
    var labels = (phase.dataset.labels || 'Em andamento|Em corte|A diferença').split('|');
    var bumps = [];
    for (var i=0;i<24;i++){ var bx = 520 + i*230; bumps.push(bx); el('path', {d:'M' + (bx-34) + ' 600 Q' + bx + ' 572 ' + (bx+34) + ' 600 Z', 'class':'wh__bump'}, bumpsG); }
    var tick = false;
    function lift(x, travel){
      var h = 0;
      bumps.forEach(function(bx){ var d = Math.abs((bx - travel) - x); if (d < 60) h = Math.max(h, 28*Math.cos(d/60*Math.PI/2)); });
      return h;
    }
    function render(){
      tick = false;
      var p = RM ? .8 : progress(sec);
      var roll = seg(p, 0, .42), travel = roll*2400;
      ground.setAttribute('transform', 'translate(' + (-travel).toFixed(1) + ' 0)');
      var ang = travel/170*180/Math.PI;
      eva.spin.setAttribute('transform', 'rotate(' + ang.toFixed(1) + ')');
      pl.spin.setAttribute('transform', 'rotate(' + ang.toFixed(1) + ')');
      var hp = lift(1160, travel), he = lift(440, travel)*.35;
      var jit = hp > 1 ? Math.sin(travel*.35)*3 : 0;
      plG.setAttribute('transform', 'translate(' + jit.toFixed(1) + ' ' + (430 - hp*1.25).toFixed(1) + ') rotate(' + (jit*.6).toFixed(2) + ')');
      evaG.setAttribute('transform', 'translate(0 ' + (430 - he).toFixed(1) + ')');
      noise.style.opacity = (roll > 0 && roll < 1 ? clamp(hp/20, .15, 1) : 0).toFixed(2);
      var cut = ease(seg(p, .46, .64));
      drawCut(eva, cut*Math.PI*0.9);
      drawCut(pl, cut*Math.PI*0.9);
      if (cut > .6) sec.setAttribute('data-cut',''); else sec.removeAttribute('data-cut');
      var rs = seg(p, .68, .9);
      rows.forEach(function(r, i){ if (rs > i/rows.length + .02) r.setAttribute('data-show',''); else r.removeAttribute('data-show'); });
      phase.textContent = p < .46 ? labels[0] : (p < .68 ? labels[1] : labels[2]);
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    var on = function(){ if (!tick){ tick = true; requestAnimationFrame(render); } };
    window.addEventListener('scroll', on, {passive:true});
    render();
  }

  function init(){
    document.querySelectorAll('[data-an]').forEach(function(s){ try { initAnatomy(s); } catch(e){ if (window.console) console.error(e); } });
    document.querySelectorAll('[data-wh]').forEach(function(s){ try { initWheels(s); } catch(e){} });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
